import { render, staticRenderFns } from "./LayerResources.vue.js?vue&type=template&id=5a437ffc!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./LayerResources.vue?vue&type=template&id=5a437ffc"
import script from "./LayerResources.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./LayerResources.vue?vue&type=script&lang=js"
export * from "./LayerResources.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./LayerResources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports